// extracted by mini-css-extract-plugin
export default {"currentPlanLabel":"cgKknx31t1KXSfOxHMQE","dropdownMenu":"qyA6v8_NI8aQzXMhp4GY","commandPaletteShortcut":"LisN7M27zeW_h60y8eqe","commandPaletteShortcutKey":"rDR0KXxFDknupvbHdtNz"};